// extracted by mini-css-extract-plugin
module.exports = {"root":"AddToCartBtn_root__V39eE","content-wrapper":"AddToCartBtn_content-wrapper__iH576","icons":"AddToCartBtn_icons__q3qBb","label":"AddToCartBtn_label__EHNN2"};